import { FileText } from "lucide-react";

import type { AssetFileRef } from "./upload-assets/types";

const EXT_COLORS: Record<string, string> = {
  AEP: "#7c3aed",
  AI: "#ea580c",
  PDF: "#dc2626",
  PSD: "#2563eb",
};

function extOf(name: string): string | undefined {
  return name.match(/\.([\dA-Za-z]+)$/)?.[1]?.toUpperCase();
}

/**
 * A single uploaded-asset tile. Renders from the brief's durable `url` — no
 * metadata lookup. Anything that isn't an image (a PSD, a PDF) falls back to
 * the colored extension tile.
 */
export function AssetThumb({ file }: { file: AssetFileRef }) {
  const isImage = (file.mime ?? "").startsWith("image/");
  const ext = extOf(file.name);

  return (
    <div
      className="aspect-square overflow-hidden rounded-lg border border-border-secondary bg-bg-secondary"
      title={file.name}
    >
      {isImage ? (
        <img
          alt={file.name}
          className="size-full object-cover"
          src={file.url}
        />
      ) : (
        <div className="flex size-full flex-col items-center justify-center gap-1">
          <span
            className="flex size-8 items-center justify-center rounded-md text-white"
            style={{ backgroundColor: (ext && EXT_COLORS[ext]) || "#6b7280" }}
          >
            <FileText className="size-4" />
          </span>
          {ext ? (
            <span className="text-[10px] font-semibold text-text-secondary">
              {ext}
            </span>
          ) : null}
        </div>
      )}
    </div>
  );
}
